module.exports = __webpack_public_path__ + "static/media/S30.7213cbe4.png";